import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Typography, Grid, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import './LoanProductInfo.scss';
const LoanProductInfo = ({ loanProductDetails }) => {
    console.log("loanProductDetailsssssssss===============",loanProductDetails);
    
    const statusMap = {
        "0": "Inactive",
        "1": "Eligible",
        "2": "Not eligible",
        "3": "Flagged",
        "4": "Blocked",
    };
      
    const pieData = [
        { name: "Outstanding Loan", value: parseFloat(loanProductDetails?.outstandingloan) },
        { name: "Available for Loan", value: parseFloat(loanProductDetails?.availableforloan) },
        { name: "Unconfirmed Payments", value: parseFloat(loanProductDetails?.unconfirmedpaymentamount) },
    ];
      
    const COLORS = ["#FF6384", "#36A2EB", "#F28C28"];

    const CustomTooltip = ({ active, payload, pieData }) => {
        if (active && payload && payload.length) {
            const total = pieData.reduce((sum, entry) => sum + entry.value, 0);
            const percent = ((payload[0].value / total) * 100).toFixed(2);
    
            return (
                <Box sx={{ background: "white", padding: "8px", border: "1px solid #ccc", borderRadius: "5px" }}>
                    <Typography variant="body2">{payload[0].name}: {payload[0].value.toLocaleString()}</Typography>
                    <Typography variant="body2">({percent}%)</Typography>
                </Box>
            );
        }
        return null;
    };
    
    return (
        <Box sx={{ padding: "0px 22px", minHeight: "70vh", display: "flex", flexDirection: "column", overflowY:"auto" }}>
            <Grid container spacing={3} >
                {/* Summary Cards */}
                <Grid item xs={12} sm={6} md={3} height={'100%'}>
                    <Card className="grid-cards">
                        <CardContent>
                            <Typography variant="h6">Eligible Amount</Typography>
                            <Typography variant="h4">{Number(loanProductDetails?.eligibleamount).toLocaleString("en-US", { minimumFractionDigits: 2 })}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card className="grid-cards">
                        <CardContent>
                            <Typography variant="h6">Available Loan</Typography>
                            <Typography variant="h4">{Number(loanProductDetails?.availableforloan).toLocaleString("en-US", { minimumFractionDigits: 2 })}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card className="grid-cards">
                        <CardContent>
                            <Typography variant="h6">Outstanding Loan</Typography>
                            <Typography variant="h4">{Number(loanProductDetails?.outstandingloan).toLocaleString("en-US", { minimumFractionDigits: 2 })}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card className="grid-cards">
                        <CardContent>
                            <Typography variant="h6">Active Loans</Typography>
                            <Typography variant="h4">{loanProductDetails?.activeloancount}</Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid container item spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Card className="grid-cards">
                            <CardContent>
                                <Typography variant="h6">Loan Breakdown</Typography>
                                <ResponsiveContainer width="100%" height={300}>
                                    <PieChart>
                                        <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={({ value }) => value.toLocaleString("en-US", { minimumFractionDigits: 2 })}>
                                            {pieData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        {/* <Tooltip /> */}
                                        <Tooltip content={<CustomTooltip pieData={pieData} />} />
                                    </PieChart>
                                </ResponsiveContainer>

                                <Box display="flex" justifyContent="center" mt={2}>
                                    {pieData.map((entry, index) => {
                                        const total = pieData.reduce((sum, item) => sum + item.value, 0);
                                        const percent = ((entry.value / total) * 100).toFixed(2);

                                        return (
                                            <Box key={index} display="flex" alignItems="center" mx={2}>
                                                <Box
                                                    sx={{
                                                        width: 12,
                                                        height: 12,
                                                        backgroundColor: COLORS[index % COLORS.length],
                                                        borderRadius: "50%",
                                                        marginRight: 1,
                                                    }}
                                                />
                                                <Typography variant="body2">
                                                    {entry.name}: {entry.value.toLocaleString()} ({percent}%)
                                                </Typography>
                                            </Box>
                                        )
                                    })}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Card className="grid-cards">
                            <CardContent>
                                <Typography variant="h6" className="mb-2">Detailed Loan Info</Typography>
                                <TableContainer component={Paper} sx={{ maxHeight: "300px", overflowY: "auto", boxShadow:"0px 0px 0px 0px" }}>
                                    <Table>
                                        {/* <TableHead>
                                            <TableRow>
                                            <TableCell>Category</TableCell>
                                            <TableCell align="right">Amount</TableCell>
                                            </TableRow>
                                        </TableHead> */}
                                        <TableBody>
                                            {[
                                                { label: "Outstanding Loan Fees", value: Number(loanProductDetails?.outstandingloanfees).toLocaleString("en-US", { minimumFractionDigits: 2 }) },
                                                { label: "Outstanding Late Fees", value: Number(loanProductDetails?.outstandingloanlatefees).toLocaleString("en-US", { minimumFractionDigits: 2 }) },
                                                { label: "Unconfirmed Payments", value: Number(loanProductDetails?.unconfirmedpaymentamount).toLocaleString("en-US", { minimumFractionDigits: 2 }) },
                                                { label: "Loan Due Amount", value: Number(loanProductDetails?.loandueamount).toLocaleString("en-US", { minimumFractionDigits: 2 }) },
                                                { label: "Opt In Date", value: loanProductDetails?.optindate },
                                            ].map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.label}</TableCell>
                                                <TableCell align="right">{row.value}</TableCell>
                                            </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

                {/* Status Chip */}
                <Grid item xs={12} className="mb-5 pb-3">
                    <Card className="grid-cards">
                        <CardContent>
                            <Typography variant="h6">Status</Typography>
                            <Chip label={statusMap[loanProductDetails?.status]} color={loanProductDetails?.status === "2" ? "warning" : "success"} />
                        </CardContent>
                    </Card>
                </Grid>

                {/* Detailed Table */}
                {/* <Grid item xs={12} flexGrow={1}>
                    <TableContainer component={Paper} sx={{ maxHeight: "300px", overflowY: "auto" }}>
                        <Table>
                        <TableHead>
                            <TableRow>
                            <TableCell>Category</TableCell>
                            <TableCell align="right">Amount</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {[
                            { label: "Outstanding Loan Fees", value: loanProductDetails?.outstandingloanfees },
                            { label: "Outstanding Late Fees", value: loanProductDetails?.outstandingloanlatefees },
                            { label: "Unconfirmed Payments", value: loanProductDetails?.unconfirmedpaymentamount },
                            ].map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.label}</TableCell>
                                <TableCell align="right">₹{row.value}</TableCell>
                            </TableRow>
                            ))}
                        </TableBody>
                        </Table>
                    </TableContainer>
                </Grid> */}
            </Grid>
        </Box>
    );
};

export default LoanProductInfo;
